import React, { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { fetchProduitsByVendeur, supprimerProduit } from '../../../services/vendeurs/produitService';
import '../../../styles/vendeurs/MesProduit.css';
import { FaEdit, FaTrash } from 'react-icons/fa';

function MesProduits() {
  const [produits, setProduits] = useState([]);
  const [vendeur, setVendeur] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const produitsParPage = 15;

  const navigate = useNavigate();

  useEffect(() => {
    const stored = localStorage.getItem('vendeurConnecte');
    if (stored) {
      try {
        const parsed = JSON.parse(stored);
        if (parsed && parsed.id) {
          setVendeur(parsed);
          fetchProduitsByVendeur(parsed.id).then(setProduits);
        } else {
          navigate('/vendeur/login');
        }
      } catch (err) {
        console.error("Erreur parsing vendeurConnecte :", err);
        navigate('/vendeur/login');
      }
    } else {
      navigate('/vendeur/login');
    }
  }, [navigate]);

  const handleEdit = (prod) => {
    navigate(`/vendeur/produits/edit/${prod.id}`, { state: prod });
  };

  const handleDelete = async (id) => {
    if (window.confirm("Supprimer ce produit ?")) {
      try {
        await supprimerProduit(id, vendeur.id);
        alert('Produit supprimé');
        setProduits(prev => prev.filter(p => p.id !== id));
      } catch (err) {
        alert("Erreur suppression produit");
      }
    }
  };

  if (!vendeur) return null;

  // Pagination
  const indexDernier = currentPage * produitsParPage;
  const indexPremier = indexDernier - produitsParPage;
  const produitsAffiches = produits.slice(indexPremier, indexDernier);
  const totalPages = Math.ceil(produits.length / produitsParPage);

  const changerDePage = (numero) => {
    if (numero >= 1 && numero <= totalPages) setCurrentPage(numero);
  };

  return (
    <div className="mes-produits-container">
      <div className="mes-produits-header">
        <h2>🧾 Mes Produits</h2>
        <Link to="/vendeur/produits/ajouter" className="ajouter-btn">➕ Ajouter un produit</Link>
      </div>

      <div className="table-responsive">
        <table className="mes-produits-table">
          
          <thead>
            <tr>
              <th>Nom</th>            
              <th>Catégorie</th>
              <th>Description</th>
              <th>Prix</th>
              <th>Stock</th>
              <th>Unité</th>
              <th>Lieu</th>
              <th>Quantité min</th>
              <th>Description détaillée</th>
              <th>Statut</th>
              <th>Action</th>
            </tr>
          </thead>
        <tbody>
  {produitsAffiches.map((produit) => (
    <tr key={produit.id}>
      <td>{produit.title || '—'}</td>          
      <td>{produit.categorie || '—'}</td>
      <td>{produit.description}</td>
      <td>{produit.price} Ar</td>
      <td>{produit.stock}</td>
      <td>{produit.unite}</td>
      <td>{produit.lieu}</td>
      <td>{produit.quantite_min}</td>
      <td>{produit.description_detaillee}</td>
      <td style={{ color: produit.statut === 'en_attente' ? 'orange' : 'green' }}>
        {produit.statut === 'en_attente' ? '⏳ En attente' : '✅ Validé'}
      </td>
          <td className="action-buttons">
            {produit.statut === 'en_attente' ? (
              <>
                <FaEdit
                  style={{ fontSize: '20px', color: 'green', display: 'inline-block', cursor: 'pointer' }}
                  onClick={() => handleEdit(produit)}
                />
                <FaTrash
                  className="icon delete-icon"
                  onClick={() => handleDelete(produit.id)}
                />
              </>
            ) : (
              <span style={{ color: '#999', fontSize: '0.9rem' }}>Non modifiable</span>
            )}
          </td>

    </tr>
  ))}
</tbody>

        </table>
      </div>

      {/* Pagination */}
      <div className="pagination">
            {Array.from({ length: totalPages }, (_, i) => (
              <button
                key={i + 1}
                className={`pagination-button ${currentPage === i + 1 ? 'active' : ''}`}
                onClick={() => changerDePage(i + 1)}
              >
                {i + 1}
              </button>
            ))}
        </div>
    </div>
  );
}

export default MesProduits;
